import * as msal from '@azure/msal-browser';
  import apiService from './api/api.service.js';
let msalApp;

// App.vue, header.vue, and page-level components (e.g. LockExtensionLanding.vue)
// each call login()/acquireTokenResponse() independently on mount. MSAL only
// allows one interactive redirect at a time, so if two of those fire before the
// first completes it throws "interaction_in_progress". Routing every redirect
// call through this single shared promise means only the first caller actually
// invokes MSAL; everyone else just awaits the same in-flight result.
let inFlightInteraction = null;

function runInteractive(startRedirect) {
  if (!inFlightInteraction) {
    inFlightInteraction = Promise.resolve()
      .then(startRedirect)
      .finally(() => { inFlightInteraction = null });
  }

  return inFlightInteraction;
}

export default {

  async init() {
    // Enforce Singleton
    if (msalApp) return msalApp;

    const config = {
      auth: {
        clientId: '82ee22b7-ba97-4154-ba13-7d8d12faed3f',
        authority: 'https://login.microsoftonline.com/2b7cd331-5fc1-498e-837a-460368566497',
        redirectUri: '/',
        postLogoutRedirectUri: '/'
      },
      cache: {
        cacheLocation: 'localStorage'
      },
    }

    msalApp = new msal.PublicClientApplication(config);

    return msalApp;
  },

  clientId() {
    if (!msalApp) {
      return null;
    }

    return msalApp.config.auth.clientId;
  },

  async login(scopes = []) {
    if (!msalApp) return;

    await runInteractive(() => msalApp.loginRedirect({
      scopes,
      prompt: 'select_account',
      domainHint: '2b7cd331-5fc1-498e-837a-460368566497'
    }));
  },

  logout() {
    if (!msalApp) return;

    // Clear local storage
    localStorage.clear();

    // Clear session cookies (if any)
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    });

    msalApp.logoutRedirect();
  },

  user() {
    if (!msalApp) return null;

    const currentAccounts = msalApp.getAllAccounts();
    if (!currentAccounts || currentAccounts.length === 0) {
      // No user signed in
      return null;
    } else if (currentAccounts.length > 1) {
      return currentAccounts[0];
    } else {
      return currentAccounts[0];
    }
  },

  async acquireTokenResponse(scopes = ['api://82ee22b7-ba97-4154-ba13-7d8d12faed3f/Files.Read']) {
    if (!msalApp) return null;

    const accessTokenRequest = {
      scopes,
      account: this.user()
    }

    let tokenRes;
    try {
      tokenRes = await msalApp.acquireTokenSilent(accessTokenRequest);
    } catch (err) {
      tokenRes = await runInteractive(() => msalApp.acquireTokenRedirect(accessTokenRequest));
    }

    if (!tokenRes.accessToken) {
      throw new Error("accessToken missing in response");
    }
    // Store the azureId in localStorage
    const homeAccountId = tokenRes.account.homeAccountId;
    const azureId = homeAccountId.split('.')[0]; // Take only the first part

    localStorage.setItem('azure_id', azureId);
    localStorage.setItem('authenticated_azureid', azureId);
    localStorage.setItem('user_name', tokenRes.account.name);
    await this.substitueImpersonation(azureId,tokenRes)
    return tokenRes;
  },
  async substitueImpersonation(azureId, tokenRes){
    // Roles are fetched centrally by App.vue – here we only handle
    // the impersonation azure_id swap when roles are already stored.
    let userRolesFromLocalStorage = localStorage.getItem('user_roles');
    if (userRolesFromLocalStorage && userRolesFromLocalStorage.includes("Impersonation")) {
      let impersonationId = localStorage.getItem('imp_azureid');
      if (impersonationId) {
        localStorage.setItem('azure_id', impersonationId);
      }
    }
  },
  clearLocal() {
    if (msalApp) {
      for (let entry of Object.entries(localStorage)) {
        let key = entry[0];
        if (key.includes('login.windows')) {
          localStorage.removeItem(key);
        }
      }
    }
  }
};
